import {
  FontColorEnum,
  FontWeightEnum,
  IconSizeEnum,
  Tooltip,
  TooltipIcon,
  Typography,
} from '@acceso/design-system';

type InfoFormFieldHeaderProps = {
  title: string;
  tooltip: string;
};

export function InfoFormFieldHeader({ title, tooltip }: InfoFormFieldHeaderProps) {
  return (
    <div className="flex items-center gap-1">
      <Typography color={FontColorEnum.Medium20} weight={FontWeightEnum.Bold}>
        {title}
      </Typography>

      <Tooltip help={tooltip} grow>
        <TooltipIcon className="text-accent-active-primary-30" size={IconSizeEnum.MD} />
      </Tooltip>
    </div>
  );
}
